import { call, put, takeLatest } from 'redux-saga/effects'
import { navigate } from '@reach/router'
import * as uifApi from '../apiModules/uif'
import * as uifModule from '../modules/uif'

function* generateUifDeclarationFile({ payload }) {
  try {
    const response = yield call(uifApi.generateUifDeclarationFile, payload)

    const { fileName, content, mimeType = 'text/plain' } = response.data

    const blob = new Blob([content], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)

    yield put(uifModule.generateUifDeclarationFileSuccess())

    return navigate('/dashboard/generate-uif-declaration?generateSuccess=true')
  } catch (err) {
    return yield put(
      uifModule.generateUifDeclarationFileFailure((err.response && err.response.data) || err)
    )
  }
}

export const uifSagas = [
  takeLatest(uifModule.GENERATE_UIF_DECLARATION_FILE, generateUifDeclarationFile)
]
